export enum AllocationRule {
  ByCommitmentAndClosingDate = 'ByCommitmentAndClosingDate',
  Manual = 'Manual',
  LinkedAction = 'LinkedAction',
  ApprovedFees = 'ApprovedFees',
  PerOriginalInvestment = 'PerOriginalInvestment',
  ProRata = 'ProRata',
}
